




{
  document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
      const MultipleSliders = document.querySelectorAll(".testimonialSliderSwiper");
      MultipleSliders.forEach((slider, index) => {
        const prevArrow = slider.parentElement.querySelector(".prev");
        const nextArrow = slider.parentElement.querySelector(".next");
        new Swiper(slider, {
          direction: "horizontal",
          // loop: true,
          speed: 1000,
          //   autoplay: {
          //     delay: 1000,
          //     disableOnInteraction: false,
          //   },
          grabCursor: true,
          navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow,
          },
           breakpoints: {
                150: {
                    slidesPerView: 1.2,
                    spaceBetween: 10,
                },
                576: {
                    slidesPerView: 2.5,
                    spaceBetween: 15,
                },
                769: {
                    slidesPerView: 3,
                    spaceBetween: 15,
                },
                 1025: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
            },
        });
      });
    };
    MultipleSlider();
  });
}

{
  document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
      const MultipleSliders = document.querySelectorAll(".Products__lists");
      MultipleSliders.forEach((slider, index) => {
        const prevArrow = slider.parentElement.querySelector(".prev");
        const nextArrow = slider.parentElement.querySelector(".next");
        new Swiper(slider, {
          direction: "horizontal",
          // loop: true,
          speed: 1000,
          //   autoplay: {
          //     delay: 1000,
          //     disableOnInteraction: false,
          //   },
          grabCursor: true,
          navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow,
          },
          breakpoints: {
            150: {
              slidesPerView: 1.2,
              spaceBetween: 10,
            },
            576: {
              slidesPerView: 2,
              spaceBetween: 15,
            },
            769: {
              slidesPerView: 2.6,
              spaceBetween: 15,
            },
            1025: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            1200: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          },
        });
      });
    };
    MultipleSlider();
  });
}

{
  document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".why-choose-video").forEach((section) => {
    const slider = section.querySelector(".videos_sliders");
    const nextBtn = section.querySelector(".swiper-button-next");
    const prevBtn = section.querySelector(".swiper-button-prev");
    new Swiper(slider, {
      direction: "horizontal",
      grabCursor: true,
      speed: 1000,

      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },

      breakpoints: {
        150: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        576: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
        769: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
        1025: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
      },
    });
  });
});
}

{
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".productSliderSecSlider").forEach((slider) => {
        new Swiper(slider, {
            direction: "horizontal",
            loop: true,
            loopAdditionalSlides: 6, // tune this instead of manually cloning DOM
            effect: "slide",
            speed: 1000,
            centeredSlides: true,
            grabCursor: true,
            watchOverflow: true, // disables loop gracefully if not enough slides exist
            breakpoints: {
                300: { slidesPerView: 1.2, spaceBetween: 10 },
                576: { slidesPerView: 2.2, spaceBetween: 15 },
                769: { slidesPerView: 2.7, spaceBetween: 15 },
                1025: { slidesPerView: 3.1, spaceBetween: 20 },
                1201: { slidesPerView: 3.348, spaceBetween: 20 },
            },
        });
    });
});
}



{
  document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
      const MultipleSliders = document.querySelectorAll(".testi_slider");
      MultipleSliders.forEach((slider, index) => {
        const prevArrow = slider.parentElement.querySelector(".prev");
        const nextArrow = slider.parentElement.querySelector(".next");
        new Swiper(slider, {
          direction: "vertical",
          // loop: true,
          speed: 1000,
          //   autoplay: {
          //     delay: 1000,
          //     disableOnInteraction: false,
          //   },
          grabCursor: true,
          navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow,
          },
          breakpoints: {
            150: {
              slidesPerView: 1.2,
              spaceBetween: 8,
            },
            576: {
              slidesPerView: 2,
              spaceBetween: 8,
            },
            769: {
              slidesPerView: 2.6,
              spaceBetween: 8,
            },
            1025: {
              slidesPerView: 3,
              spaceBetween: 8,
            },
            1200: {
              slidesPerView: 2.5,
              spaceBetween: 8,
            },
          },
        });
      });
    };
    MultipleSlider();
  });
}